export default __webpack_public_path__ + "static/media/icon--documentation.c2de4832.svg";